import { Injectable } from '@angular/core'
import { EventLoggingParams, LogEventKey } from 'src/app/interfaces/log'
import { GroupChemiLogEvent } from 'src/app/interfaces/log/group-chemi-log'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class GroupChemiLogService {
  constructor(private logService: LogService) {}

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, { ...params })
  }
  // [그룹 케미 전체 친구들 역할] 화면 진입
  logGroupChemiAllMembersViewed(member_cnt: number | undefined): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_ALL_MEMBERS_VIEWED, { member_cnt })
  }

  // [그룹 케미 결과] '모두 보기' 버튼 클릭
  logGroupChemiResultShowAllClicked(member_cnt: number): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_SHOW_ALL_CLICKED, { member_cnt })
  }

  // [그룹 케미 로딩] 화면 진입
  logGroupChemiLoadingViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_LOADING_VIEWED)
  }

  // [그룹 케미 생성] 화면 진입
  logGroupChemiCreateViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_VIEWED)
  }

  // [그룹 케미 생성] 공유 버튼 클릭
  logGroupChemiCreateShareButtonClicked(type: 'kakao' | 'copy', location: 'top' | 'bottom'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_SHARE_BUTTON_CLICKED, { type, location })
  }

  //그룹이름 입력창 클릭
  logGroupChemiNameInputClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_NAME_INPUT_CLICKED)
  }

  // [그룹 케미 생성] 모임 이름 모달 진입
  logGroupChemiNameInputModalViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_NAME_INPUT_MODAL_VIEWED)
  }

  // [그룹 케미 생성] 모임 이름 모달 확인 버튼 클릭
  logGroupChemiNameInputModalSubmit(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_NAME_INPUT_MODAL_SUBMIT)
  }

  // [그룹 케미 멤버 리스트] 분석 버튼 클릭
  logGroupChemiMemberListSubmit(total_member_count: number | undefined): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_MEMBER_LIST_SUBMIT, { total_member_count })
  }
  // [그룹 케미 결과] 화면 진입
  logGroupChemiResultViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_VIEWED)
  }
  // [그룹 케미 결과] 초대 화면 진입
  logGroupChemiResultInviteViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_INVITE_VIEWED)
  }
  // [그룹 케미 결과] '다른 모임에서 내 역할 확인하기' 버튼 클릭
  logGroupChemiResultAnotherChemiButtonClicked(type: 'banner' | 'floating'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_ANOTHER_CHEMI_BUTTON_CLICKED, { type })
  }
  // [그룹 케미 결과] '초대 수락하기' 버튼 클릭
  logGroupChemiResultInviteAcceptButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_INVITE_ACCEPT_BUTTON_CLICKED)
  }
  // [그룹 케미 결과] 로그인 모달 노출
  logGroupChemiResultLoginModalImpression(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_LOGIN_MODAL_IMPRESSION)
  }
  // [그룹 케미 결과] '성격 유형이 필요해요' 화면 노출
  logGroupChemiResultMbtiNeededViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_MBTI_NEEDDED_VIEWED)
  }
  // [그룹 케미 결과] '성격 유형 하러가기' 버튼 클릭
  logGroupChemiResultMbtiQuizButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_MBTI_QUIZ_BUTTON_CLICKED)
  }
  // [그룹 케미 결과] '이상형 MBTI 궁합보기' 버튼 클릭
  logGroupChemiResultIdealMatchButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_IDEAL_MATCH_BUTTON_CLICKED)
  }
  // [그룹 케미 결과] '이상형 MBTI 궁합보기' 배너 제거 버튼 클릭
  logGroupChemiResultIdealMatchCloseButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_IDEAL_MATCH_CLOSE_BUTTON_CLICKED)
  }
  // [그룹 케미 결과] '삭제된 그룹' 화면 진입
  logGroupChemiResultDeletedChemiViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_DELETED_CHEMI_VIEWED)
  }

  //'새궁합' 버튼 클릭
  logGroupChemiCreateAddButtonCLicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_ADD_BUTTON_CLICKED)
  }

  //그룹 선택 화면 조회
  logGroupChemiGroupSelectViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_GROUP_SELECT_VIEWED)
  }

  //그룹 선택
  logGroupChemiGroupSelectGroupCardClicked(groupName: string, groupMember: number): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_GROUP_SELECT_GROUP_CARD_CLICKED, { groupName, groupMember })
  }

  logGroupChemiRequirementViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_MBTI_REQUIREMENT_VIEWED)
  }

  logGroupChemiRequirementSubmit(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_MBTI_REQUIREMENT_SUBMIT)
  }

  logGroupChemiInviteShareButtonClicked(type: 'kakao' | 'copy'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_INVITE_SHARE_BUTTON_CLICKED, { type })
  }

  logGroupChemiCreateMemberListButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_MEMBER_LIST_BUTTON_CLICKED)
  }

  logGroupChemiMemberListViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_MEMBER_LIST_VIEWED)
  }

  //[그룹케미 결과] 추천 퀴즈 리스트 클릭
  logGroupChemiResultRecommendQuizClicked(quizType: 'ideal-type' | 'best-friend' | 'guess-me' | 'mbti-quiz'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_RECOMMEND_QUIZ_CLICKED, { quizType })
  }
  //[그룹케미 결과] 헤더 공유 아이콘 클릭
  logGroupChemiResultHeaderShareButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_HEADER_SHARE_BUTTON_CLICKED)
  }
  //[그룹케미 결과] 헤더 공유
  logGroupChemiResultHeaderShareClicked(type: 'kakao' | 'copy'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_HEADER_SHARE_CLICKED, { type })
  }
  //[그룹케미 결과] 하단 공유 아이콘 클릭
  logGroupChemiResultShareClicked(type: 'kakao' | 'copy'): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_SHARE_CLICKED, { type })
  }
  //[그룹케미 결과] 1:1 케미 보기 버튼 클릭
  logGroupChemiResultPersonalChemiButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_RESULT_PERSONAL_CHEMI_BUTTON_CLICKED)
  }
  //[홈] 그룹케미 배너 클릭
  logHomeGroupChemiClicked(): void {
    this.eventLogging(GroupChemiLogEvent.HOME_GROUP_CHEMI_CLICKED)
  }
  // [그룹케미 생성] (웹)로그인 모달 진입
  logGroupChemiCreateLoginModalViewed(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_LOGIN_MODAL_VIEWED)
  }
  // [그룹케미 생성] (웹)로그인 모달 - 로그인 버튼 클릭
  logGroupChemiCreateLoginModalButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_LOGIN_MODAL_BUTTON_CLICKED)
  }
  // [그룹케미 생성] (웹) 친구 초대하기 버튼 클릭
  logGroupChemiCreateInviteButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_INVITE_BUTTON_CLICKED)
  }
  // [그룹케미 생성] (웹) 친구 초대하기 QR CODE 버튼 클릭
  logGroupChemiCreateQRCodeButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_CREATE_QR_CODE_BUTTON_CLICKED)
  }
  // [그룹케미 멤버 리스트] (웹) QR CODE 버튼 클릭
  logGroupChemiMemberListQRCodeButtonClicked(): void {
    this.eventLogging(GroupChemiLogEvent.GROUP_CHEMI_MEMBER_LIST_QR_CODE_BUTTON_CLICKED)
  }
}
